<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        v-if="!adaptive"
          dark
          v-bind:disabled="enabled"
          v-bind="attrs"
          v-on="on"
          class="mb-1"
          x-large color="primary" max-width="224px"
        >
        <v-icon class="pr-2 ml-2" left large v-if="buttonIcon">{{buttonIcon}}</v-icon>
          {{buttonText}}
        </v-btn>

        <v-btn
        v-else
          color="primary"
          dark
          v-bind:disabled="enabled"
          v-bind="attrs"
          v-on="on"
          large
          class="mb-1 "
          block max-width="224px"
        >
        <v-icon large left class="pr-5 ml-2" v-if="buttonIcon">{{buttonIcon}}</v-icon>
          {{buttonText}}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Новая учетная запись</span>
        </v-card-title>
        <v-subheader>Заполните форму чтобы привязать новую учетную запись</v-subheader>
        <v-card-text>
            <v-form
                ref="form"
                v-model="valid"
            >
            <v-row>
                <v-col cols="12" sm="12">
                    <v-text-field
                    v-model="accountUrl"
                    placeholder="например (web.satmon.net)"
                    :rules="[v => !!v || 'Обязательное поле', v => /\s/.test(v) === false || 'адрес сайта не должен содержать пробелов']"
                    label="URL Адрес сайта (без http://)"
                    required
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-text-field
                    v-model="accountLogin"
                    placeholder="например demo"
                    :rules="[v => !!v || 'Обязательное поле', v => /\s/.test(v) === false || 'логин не должен содержать пробелов']"
                    label="Логин"
                    required
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <v-text-field
                    v-model="accountPassword"
                    type="password"
                    :rules="[v => !!v || 'Обязательное поле']"
                    label="Пароль"
                    required
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-select
                    v-model="accountType"
                    :items="accountTypes"
                    :rules="[v => !!v || 'Обязательное поле']"
                    label="Система мониторинга"
                    required
                    ></v-select>
                </v-col>
            </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="primary" :disabled="!valid" text @click="validate">Продолжить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: {
    buttonText: String,
    buttonIcon: String,
    buttonSize: String,
    adaptive: Boolean,
    enabled: Boolean
  },
  data: () => ({
    accountTypes: ['АвтоГРАФ Web', 'Wialon (недоступен)'],
    accountUrl: '',
    accountLogin: '',
    accountPassword: '',
    accountType: 'АвтоГРАФ Web',
    valid: true,
    dialog: false
  }),
  methods: {
    validate () {
      this.$refs.form.validate()
      this.dialog = false
      this.$emit('onValidate', {
        uri: this.accountUrl,
        login: this.accountLogin,
        password: this.accountPassword,
        accountType: this.accountType
      })
    }
  }
}
</script>
